<template>
  <div class="nx-signing-modal-complete">
    <h4>{{$t('SigningSucceeded')}}</h4>
  </div>
</template>

<script>
import { ECounterApi } from "@/api";
export default {
  props: {
    value: {},
  },
  data() {
    return {
      files: []
    };
  },
  async created() {
      //await ECounterApi.confirmSign(this.value.fileId);
      const { files } = this.value;
      this.files = files;
      this.$emit("signComplete");
  }
  ,  i18n: {
    messages: {
      en: {
        SigningSucceeded: 'Adding e-Certificate succeeded'
      },
      zh_hk: {
        SigningSucceeded: '成功加入電子證書'
      },
      zh_cn: {
        SigningSucceeded: '成功加入电子证书'
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nx-signing-modal-complete {
  text-align: center;
}
</style>
